// extracted by mini-css-extract-plugin
module.exports = {"banner-img":"style_banner-img__NBPAc","top":"style_top__2oecf","hidden":"style_hidden__1vjRp"};